// @theme component
import React, { FC, useCallback, useEffect, useState } from 'react';
import { componentService } from '@core/js/services/component.service';
import { useDTAG } from '@theme/js/hooks/useDTAG';
import { getFormattedUrlAsync } from '@theme/js/utils/url.util';
import { useCustomSelector } from '@core/js/store/hooks';
import { getTempToken } from '@core/js/hooks/auth/pas';
import { APP_REDUCER, USER_REDUCER, DEVICE_REDUCER } from '@core/js/store/constants';

type IframeProps = {
    scrolling: string,
    url: string,
    dtag?: string,
}

export const Iframe: FC<IframeProps> = ({ scrolling, url, dtag = '' }) => {
    const [formattedUrl, setFormattedUrl] = useState('');
    const dtagUrl = useDTAG(dtag);
    const app = useCustomSelector(APP_REDUCER);
    const user = useCustomSelector(USER_REDUCER);
    const device = useCustomSelector(DEVICE_REDUCER);

    const formatUrlAsync = useCallback(async () => {
        setFormattedUrl(await getFormattedUrlAsync(url || dtagUrl, user, app, getTempToken, device));
    }, [dtagUrl, url, user, app, device]);

    useEffect(() => {
        formatUrlAsync();
    }, [formatUrlAsync]);

    return (
        <div className={`iframe-replacer ${scrolling ? 'iframe-with-scrolling-replacer' : ''}`}>
            <iframe loading='lazy' src={formattedUrl} {...!scrolling && { scrolling: 'no' }} ></iframe>
        </div>
    );
};

componentService.registerWebContentComponents({ Iframe });
